export const TIME_FORMATS = {
  TWELVE_HOUR: "hh:mm A",
  TWENTY_FOUR_HOUR: "HH:mm",
};

export const hours = (timeFormat: string = TIME_FORMATS.TWELVE_HOUR) =>
  timeFormat === TIME_FORMATS.TWELVE_HOUR
    ? Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"))
    : Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));

export const minutes = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, "0"),
);

export const Meridiem = ["AM", "PM"];
